import { FormGroup, InputGroup } from '@blueprintjs/core';
import * as React from 'react';

import type { DataSourceSubFormProps } from 'src/ui/containers/dialogs/DataSourceForm';
import * as copy from 'src/ui/templates/copy';

export const DataSourceCassandraForm: React.VFC<DataSourceSubFormProps> = ({
  dataSource,
  formHandler,
  disabled,
}) => {
  const { formData, handleTextFieldChange } = formHandler;

  return (
    <>
      <FormGroup
        labelFor="data-source-cassandra-name"
        label={copy.components.dataSourceDialog.form.name}
        helperText={copy.components.dataSourceDialog.form.nameHelp}
      >
        <InputGroup
          id="data-source-cassandra-name"
          value={dataSource.name}
          fill
          disabled
        />
      </FormGroup>
      <FormGroup
        label={copy.components.dataSourceDialog.form.cassandra.point}
        labelFor="data-source-cassandra-point"
      >
        <InputGroup
          id="data-source-cassandra-point"
          value={formData['cassandra.contact.point']}
          disabled
          name="cassandra.contact.point"
          onChange={handleTextFieldChange}
        />
      </FormGroup>
      <FormGroup
        label={copy.components.dataSourceDialog.form.cassandra.username}
        labelFor="data-source-cassandra-username"
      >
        <InputGroup
          autoFocus
          id="data-source-cassandra-username"
          name="cassandra.username"
          autoComplete="username"
          value={formData['cassandra.username']}
          disabled={disabled}
          onChange={handleTextFieldChange}
        />
      </FormGroup>
      <FormGroup
        label={copy.components.dataSourceDialog.form.cassandra.password}
        labelFor="data-source-cassandra-password"
      >
        <InputGroup
          id="data-source-cassandra-password"
          name="cassandra.password"
          type="password"
          autoComplete="password"
          disabled={disabled}
          onChange={handleTextFieldChange}
        />
      </FormGroup>
    </>
  );
};
